import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { companyType } from '../../types';

const initialState: companyType = {
    is_company: false,
    is_loading_company: false,
    company: {
        company_id: '', 
        name: '', 
        phone: '', 
        email: '', 
        address: ''
    },
    add_success: null,
    add_success_message: '',
    add_company_loading: false,
    is_updating_company: false,
};

export const companySlice = createSlice({
    name: 'company',
    initialState,
    reducers: {
        getCompanyExistance: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_company: action.payload
            };
        },
        addCompanyLoading: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                add_company_loading: action.payload
            };
        },
        addCompany: (state, action: PayloadAction<object>) => {
            const { success, message, company }: any = action.payload;
            return {
                ...state,
                company,
                add_success_message: message,
                add_success: success,
            };
        },
        getCompany: (state, action: PayloadAction<object>) => {
            return {
                ...state,
                company: action.payload
            };
        },
        isLoadingCompany: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_loading_company: action.payload,
            };
        },
        onUpdatingCompany: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_updating_company: action.payload
            };
        },
    }
});

export const { getCompanyExistance, addCompany, addCompanyLoading, getCompany, onUpdatingCompany, isLoadingCompany } = companySlice.actions;

export default companySlice.reducer;